import wangeditor from './wangeditor'

wangeditor.install = Vue => {
  Vue.component(wangeditor.name, wangeditor)
}

export {
  wangeditor
}



// WEBPACK FOOTER //
// ./src/components/framework/editor/index.js